(function () {

function UploadDragDrop($scope, TranslationService, ToastService) {
        var ctrl = this;
        var _fileExtensions = [
            { Key: 'doc', Value: 'application/msword' },
            { Key: 'docx', Value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
            { Key: 'docm', Value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
            { Key: 'xls', Value: 'application/vnd.ms-excel' },
            { Key: 'xlsx', Value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
            { Key: 'xlsm', Value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
            { Key: 'jpg', Value: 'image/' },
            { Key: 'png', Value: 'image/' },
            { Key: 'image', Value: 'image/' },
            { Key: 'video', Value: 'video/' },
            { Key: 'rar', Value: 'application/x-zip-compressed' },
            { Key: 'pdf', Value: 'application/pdf' },
            { Key: 'msg', Value: 'application/vnd.ms-outlook' },
            { Key: 'eml', Value: 'application/vnd.ms-outlook' }
        ];
        var filesReceivedAmount = 0;
        ctrl.maxFileAmountReached = false;

        ctrl.translation = TranslationService.getActiveTranslation();

        ctrl.allowedExtensions = function () {
            var keysString = _fileExtensions.map(function (extension) {
                return '.' + extension.Key;
            }).join(',');
            keysString += ',application/x-zip-compressed';
            return keysString;
        };

        var dragArea = document.querySelector('.area-upload');
        var dragText = document.querySelector('.textAttach');
        var file;

        dragArea.addEventListener('dragover', function (event) {
            event.preventDefault();
            dragText.textContent = 'Soltar el archivo';
        });

        dragArea.addEventListener('dragleave', function () {
            dragText.textContent = ctrl.attachType;
        });

        dragArea.addEventListener('drop', function (event) {
            file = event.dataTransfer.files[0];
            var isLarge = isTooLarge(file);
            if (!file || isLarge) {
                dragText.textContent = setTagAttach(0);
                return;
            }
            event.preventDefault();
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                var fileDoc = buildFileDoc(e, file);
                ctrl.addIn.Files.push(fileDoc);
                $scope.$apply();
            };

            fileReader.readAsDataURL(file);
            dragText.textContent = setTagAttach(1);
        });

        ctrl.uploadFile = function (file) {
            //Validar EXTENSIONS


            if (!file || isTooLarge(file)) return;
            var reader = new FileReader();
            reader.onload = function (e) {
                var fileDoc = buildFileDoc(e, file);
                ctrl.addIn.Files.push(fileDoc);
                $scope.$apply();
            };
            reader.readAsDataURL(file);
            dragText.textContent = setTagAttach(1);
            filesReceivedAmount++;

            if (filesReceivedAmount >= ctrl.maxFileAmount) {
                ctrl.maxFileAmountReached = true;
                $scope.$apply();
            }
        };

        ctrl.dowloadFile = function (file) {
            console.log('download file ' + file.FileUrl);
            if (!file.FileUrl) return;
            var anchor = document.createElement("a");
            document.body.appendChild(anchor);
            var url = file.FileUrl;
            anchor.href = url;
            anchor.download = file.FileName;
            anchor.click();
        };

        ctrl.removeFile = function (index) {
            var hasUpload = !ctrl.files[index].Buffer;
            if (hasUpload)
                ctrl.files[index].Delete = true;
            else
                ctrl.files.splice(index, 1);
            ctrl.addIn.Files = ctrl.files;
            $scope.$apply();
        };

        ctrl.getIconImagePath = function (extension) {            
            switch (extension) {
                case 'doc':
                case 'docx':
                case 'docm':
                    return '../../Images/word-icon.png';
                case 'xls':
                case 'xlsx':
                case 'xlsm':
                    return '../../Images/excel-icon.png';
                case 'image':
                case 'png':
                case 'jpg':
                    return '../../Images/img-icon.png';
                case 'video':
                    return '../../Images/img-icon.png';
                case 'rar':
                    return '../../Images/img-icon.png';
                case 'pdf':
                    return '../../Images/icon_3_pdf_x16.png';
                case 'msg':
                case 'eml':
                    return '../../Images/msg_icon.png';
                default:
                    return '../../Images/img-icon.png';
                    //return '../../Images/empty.png';
            }
        };            

        function isTooLarge(file) {
            var sizeInMB = Math.round(file.size / 1024) / 1000;           
            if (sizeInMB > 20) {
                ToastService.createToast(ctrl.translation.FileTooLarge, '', 4000, 'error');
                return true;
            } else {
                return false;
            }
        }

        function buildFileDoc(e, file) {
            var src = e.target.result;
            var buffer = src.split(',')[1];
            var sizeInMB = Math.round(file.size / 1024) / 1000;           
            var extension = setFileExtension(file.type, file.name);            
            return {
                FileName: file.name,
                FileSize: sizeInMB,
                FileType: file.type,
                FileExtension: extension,
                Source: src,
                Buffer: buffer,
                IsCreditNote: ctrl.isCreditNote ? ctrl.isCreditNote : false
            }
        }

        function setFileExtension(type, fileName) {
            var extension = '';

            _fileExtensions.forEach(function (ex) {
                if (type.contains(ex.Value)) extension = ex.Key;
            });

            if (extension == '') {
                extension = getFileExtension(fileName);
            }

            return extension;
        }

        function getFileExtension(filename) {
            if (!filename) {
                return '';
            }
            return filename.slice(filename.lastIndexOf(".") + 1);
        }

        function setTagAttach(i) {
            return 'Adicionar';            
        }
    }

    UploadDragDrop.$inject = ['$scope', 'TranslationService', 'ToastService'];

    seedWebApp.component('uploadDragDrop', {
        controller: UploadDragDrop,
        controllerAs: 'ctrl',
        bindings: {
            files: '<',
            addIn: '=',
            attachType: '<',
            maxFileAmount: '<',
            isCreditNote: '<',
        },
        templateUrl: '/SPA/Components/upload-drag-drop.html' + seedWebApp.buildVersion,
    });
})();